import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';

import AuthWrapper from './AuthWrapper';
import './services/translations/translationsConfig';
import store from './store/store';

import 'services/declareGlobalWindowAdditionalProperties';

const baseUrl: null | string = document
  .getElementsByTagName('base')[0]
  .getAttribute('href');
const rootElement = document.getElementById('root');

window.renderReact = () => {
  ReactDOM.render(
    <BrowserRouter basename={baseUrl === null ? '/' : baseUrl}>
      <Provider store={store}>
        <Suspense fallback={null}>
          <AuthWrapper />
        </Suspense>
      </Provider>
    </BrowserRouter>,
    rootElement
  );
};
